import React, { useMemo } from "react";
import { getAnswerText, OTHER_ANSWER } from "@common/taxSavingRules";
import { Field } from "@design-system/Field/Field";
import { Picker } from "@design-system/Picker/Picker.lib";
import { TaxQuestionAnswerComponentProps } from "./types";
import styles from "./TaxQuestionAnswerSelect.module.scss";

export const TaxQuestionAnswerSelect: React.FC<
    TaxQuestionAnswerComponentProps
> = ({ question, answer, onAnswer, labelStyle = "inside" }) => {
    const options = useMemo(
        () => [
            ...question.options.map((option) => ({
                value: getAnswerText(option),
                label: getAnswerText(option),
            })),
            { value: OTHER_ANSWER, label: OTHER_ANSWER },
        ],
        [question.options],
    );

    const label = labelStyle !== "placeholder" ? question.question : undefined;
    const placeholder =
        labelStyle === "placeholder" ? question.question : "Select";

    const select = (
        <Picker.Select
            items={options}
            value={answer ?? null}
            onValueChange={(value) => {
                if (value) {
                    onAnswer(question.key, value);
                }
            }}
            placeholder={placeholder}
            trigger={
                <Picker.Button
                    variant="primary"
                    block
                    size="xl"
                    className={styles.trigger}
                />
            }
        />
    );

    if (!label) {
        return select;
    }

    return (
        <Field label={label} control="button">
            {select}
        </Field>
    );
};
